<template>
  <div class="main-ct">
    <div class="description-ct">
      <p class="header-paragraph">
        {{ $t('Gamification_Omnichannel_Strategy_Add_Free_To_Play_Games') }}
      </p>
      <p class="description-paragraph">
        {{ $t('Gamification_Omnichannel_Strategy_Use_Xtremepush') }}
      </p>
    </div>
    <div>
      <img
        src="@/img/gamification/xp-tb-games-omnichannel.png"
        :alt="
          $t(
            'Gamification_Omnichannel_Strategy_Alt_Image_Games_For_Omnichannel'
          )
        "
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'GamificationAddToOmnichannelStrategy'
}
</script>

<style scoped>
.main-ct {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 40px;
  padding: 40px 65px;
}

.description-ct {
  display: flex;
  width: 740px;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.header-paragraph {
  color: #5c6374;
  font-size: 24px;
  font-weight: 600;
  line-height: 30px;
}

.description-paragraph {
  color: #7e8596;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
}

img {
  width: 1022px;
  height: 371px;
  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/modules/gamification/components/games-hub-upsell/GamificationAddToOmnichannelStrategy.vue